module.exports = {
  menuLinkStyle:
    "inline-flex items-center font-sans text-xs transition !text-black visited:!text-black hover:bg-gray-50 py-3.5 px-2.5",
}
